module.exports = __webpack_public_path__ + "static/cart06-34490a288dd72aa6501b0caf4f5a6fab.svg";